/** @jsx h */
import { useRef, useEffect } from 'preact/hooks';
import { labels } from '../../config';
import {
  labels as mapLabels,
  lang,
} from '../../../../1-molecules/map/map-labels';
import { MapMapbox } from '../../../../1-molecules/map/map-mapbox';
import SearchHeaderMap from '../SearchHeader/SearchHeaderMap';

let mapInstance;

const Map = ({
  list,
  consent,
  currentPage,
  itemsPerPage,
  query,
  pluginNamespace,
  showFacets,
  facets,
  facetsActive,
  sorting,
  triggerAjaxSubmit,
  searchType,
  showMaininput,
  isReset,
  toggleLoadingAnimation,
  coordinatesApi,
  resetFilters,
}) => {
  const container = useRef(null);
  const mapContainer = useRef(null);
  const mapDetail = useRef(null);
  const mapDetailContent = useRef(null);
  const mapDetailClose = useRef(null);

  useEffect(() => {
    if (consent && mapContainer.current) {
      mapInstance = new MapMapbox({
        container: container.current,
        mapContainer: mapContainer.current,
        mapDetail: mapDetail.current,
        mapDetailContent: mapDetailContent.current,
        mapDetailClose: mapDetailClose.current,
        mapFitBounds: true,
        mapData: list,
      });

      mapInstance.init();
      return;
    }

    mapInstance?.destroy();
  }, [consent]);

  useEffect(() => {
    consent && mapInstance && mapInstance.updateMarkers(list, isReset);
  }, [list, currentPage]);

  return (
    <div class="map" ref={container}>
      <div class="skip-link">
        <a href="#skip-link-target-map" class="skip-link__link">
          <span>{labels.map.skip}</span>
        </a>
      </div>
      <div class="map__map">
        <div
          id="osm-cDATA-UID"
          class="map__mapbox"
          aria-label={labels.map.heading}
          ref={mapContainer}
        />
        <div class="map__overlays">
          <div
            class="map__detail"
            id="map-detail"
            role="dialog"
            aria-label="Standortdetails"
            aria-describedby="map-detail"
            ref={mapDetail}
          >
            <button
              class="map__detail-close"
              aria-controls="map-detail"
              ref={mapDetailClose}
            >
              <span class="map__detail-icon icon icon--close">
                <svg class="icon__svg" role="img" aria-hidden="true">
                  <use href="#icon-close" />
                </svg>
                <span class="sr-only">{mapLabels.closeDetail[lang]}</span>
              </span>
            </button>
            <div class="map__detail-content" ref={mapDetailContent} />
          </div>
          <div class="map__search">
            <SearchHeaderMap
              showFacets={showFacets}
              query={query}
              facets={facets}
              facetsActive={facetsActive}
              sorting={sorting}
              triggerAjaxSubmit={triggerAjaxSubmit}
              pluginNamespace={pluginNamespace}
              searchType={searchType}
              showMaininput={showMaininput}
              resetFilters={resetFilters}
              isReset={isReset}
              toggleLoadingAnimation={toggleLoadingAnimation}
              coordinatesApi={coordinatesApi}
            />
          </div>
          <div class="map__controls">
            <button
              class="map__control map__zoom-in styled-button"
              aria-controls="osm-cDATA-UID"
              type="button"
            >
              <span class="map__icon icon icon--zoom-plus styled-button__text">
                <svg class="icon__svg" role="img" aria-hidden="true">
                  <use href="#icon-zoom-plus" />
                </svg>
                <span class="sr-only">{mapLabels.zoomIn[lang]}</span>
              </span>
            </button>
            <button
              class="map__control map__zoom-out styled-button"
              aria-controls="osm-cDATA-UID"
              type="button"
            >
              <span class="map__icon icon icon--zoom-minus styled-button__text">
                <svg class="icon__svg" role="img" aria-hidden="true">
                  <use href="#icon-zoom-minus" />
                </svg>

                <span class="sr-only">{mapLabels.zoomOut[lang]}</span>
              </span>
            </button>
            <button
              class="map__control map__fullscreen styled-button"
              aria-controls="osm-cDATA-UID"
              type="button"
            >
              <span class="map__icon icon icon--fullscreen styled-button__text">
                <svg class="icon__svg" role="img" aria-hidden="true">
                  <use href="#icon-fullscreen" />
                </svg>

                <span class="sr-only">{mapLabels.enterFullscreen[lang]}</span>
              </span>
            </button>
          </div>
        </div>
      </div>
      <div id="skip-link-target-map" tabindex="-1" aria-hidden="true" />
    </div>
  );
};

export { Map };
